import CheckboxSelectionProcessor from '../../Components/Core/Processors/CheckboxSelectionProcessor'
import CheckBoxSelectionResultProcessor from '../../Components/Core/SelectionResults/CheckBoxSelectionResultProcessor'
import TrifectaValidator from '../../Validation/TrifectaValidator'
import BetTypeInformation from '../Betting/BetTypeInformation'
import type { IConfigureBetType } from './IConfigureBetType'

export default class TrifectaConfigurator implements IConfigureBetType {
  build(): BetTypeInformation {
    return new BetTypeInformation({
      betType: 'Trifecta',
      name: 'Trifecta',
      supportsFlexi: true,
      sortOptions: ['Number', 'FixedPrice', 'Price'],
      template: 'trifecta-template',
      betSelectionTemplate: 'tri-checkbox-selection-template',
      multiBet: false,
      multiSelections: true,
      checkBoxCount: 3,
      fieldCheckBoxCount: 3,
      sameAsCheckBoxCount: 2,
      processor: new CheckboxSelectionProcessor(3),
      validator: new TrifectaValidator(),
      selectionResultProcessor: new CheckBoxSelectionResultProcessor(3),
      legs: 1,
    })
  }
}
